import { useEffect } from 'react';

const LoginPage = () => {
  useEffect(() => {
    window.location.href = 'https://app.auroragh.com/login';
  }, []);

  return null;
};

export default LoginPage;